module.exports = __webpack_public_path__ + "49212a958af8202c2d1b2a3ff8ab0c11.fbx";